import { Component, OnInit } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { BaseWdxFormControlClass } from '../../../abstract-classes/base-form-control.class';
import { IFormDynamicData } from '../../../interfaces';
import { BespokeValidators } from '../../../validators/bespoke-validators';

@Component({
    selector: 'wdx-ff-boolean-control',
    templateUrl: './form-boolean-control.component.html',
    standalone: false,
})
export class FormBooleanControlComponent
    extends BaseWdxFormControlClass
    implements OnInit
{
    constructor(
        public override controlContainer: ControlContainer,
        public override dynamicDataService: IFormDynamicData,
    ) {
        super(controlContainer, dynamicDataService);
    }

    ngOnInit(): void {
        if (this.formElement.isRequired && !this.formElement.isExclusive) {
            this.formControl?.addValidators([BespokeValidators.isTrue()]);
        }
    }
}
